export const navigate = {
    setHref: (url: string) => {
        return (window.location.href = url);
    },
    getHref: () => {
        return window.location.href;
    },
    getPathname: () => {
        return window.location.pathname;
    },
    getHost: () => {
        return window.location.host;
    },
    getHostname: () => {
        return window.location.hostname;
    },
    getOrigin: () => {
        return window.location.origin;
    },
    getSearch: () => {
        return window.location.search;
    },
    getHash: () => {
        return window.location.hash;
    },
    getProtocol: () => {
        return window.location.protocol;
    },
    getPort: () => {
        return window.location.port;
    },
    reload: () => {
        return window.location.reload();
    },
    replace: (url: string) => {
        return window.location.replace(url);
    },
    assign: (url: string) => {
        return window.location.assign(url);
    },
};
